/**
 * Step-by-Step slider functionality
 * Creates responsive step card sliders for mobile devices
 * On desktop (≥768px), displays as grid layout without slider
 * On mobile (<768px), displays as slider with pagination and partial next slide peek
 */

(async () => {

  if (!customElements.get('step-by-step-swiper')) {

    const { default: Swiper, Pagination } = await import("swiper");

    Swiper.use([
      Pagination
    ]);

    class StepByStepSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-step-by-step]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1.2,
          spaceBetween: 16,
          direction: 'horizontal',
          watchOverflow: true, // Disable if not enough slides
          observer: true, // Watch for DOM changes
          observeParents: true, // Watch parent elements for changes
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            // When window width is >= 768px
            768: {
              enabled: false, // Disable swiper on tablet and desktop
              slidesPerView: 1,
              spaceBetween: 0
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
      }

      connectedCallback() {
        // Wait for next frame to ensure CSS is applied
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.init();
          });
        });
      }

      init() {
        // Ensure container has valid dimensions before initializing
        const container = this.swiperElement;
        if (container && container.offsetWidth > 0 && container.offsetWidth < 10000) {
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        } else {
          // If dimensions are invalid, try again after a short delay
          setTimeout(() => {
            this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
          }, 100);
        }
      }

    }

    window.StepByStepSwiper = StepByStepSwiper;

    customElements.define('step-by-step-swiper', StepByStepSwiper);

  }

})();
